module.exports = "https://www.gc-qa.gnp.com.mx/085134638ffb6039d8d65acab766bed1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/doctor.svg
// module id = 684
// module chunks = 0 1